var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeauty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22852 16.3844C3.22852 16.3844 5.44076 16.1243 6.81832 16.3844C8.46351 16.6951 9.09852 17.8186 10.75 18.0939C11.8694 18.2804 13.656 18.0939 13.656 18.0939",
    stroke: "url(#paint0_linear_6446_36626)",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5097 20.9999H2.54365C-0.893766 14.212 1.51815 8.35017 8.6976 8.3501C15.8771 8.35003 18.047 14.5568 14.5097 20.9999Z",
    stroke: "url(#paint1_linear_6446_36626)",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9375 9.0337V5.78578H6.98882M12.288 9.0337V5.78578H10.0658M10.0658 5.78578V1.51221H6.98882V5.78578M10.0658 5.78578H6.98882",
    stroke: "url(#paint2_linear_6446_36626)",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2363 3.3932C10.2363 3.3932 11.9701 3.3932 12.9714 3.3932M12.9714 3.3932C13.6552 4.58935 14.168 5.95735 16.5612 5.95735C18.9544 5.95735 19.961 4.76029 19.8091 3.3932C19.6573 2.02611 18.4416 0.999499 16.5612 1C14.6808 1.17061 14.168 1.68344 12.9714 3.3932Z",
    stroke: "url(#paint3_linear_6446_36626)",
    strokeWidth: 1.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6446_36626",
    x1: 11.4441,
    y1: 18.0322,
    x2: 11.1155,
    y2: 15.4547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6446_36626",
    x1: 12.9564,
    y1: 20.0416,
    x2: 5.4142,
    y2: 7.05506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6446_36626",
    x1: 10.7288,
    y1: 8.46389,
    x2: 5.84787,
    y2: 1.61748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6446_36626",
    x1: 17.7903,
    y1: 5.58179,
    x2: 15.6201,
    y2: -0.442317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeauty);
export default __webpack_public_path__ + "static/media/Beauty.d63bec47bfe30e08893a6ed44ffefc94.svg";
export { ForwardRef as ReactComponent };